// extracted by mini-css-extract-plugin
export default {"IntroductionCard":"IntroductionCard___UA87V","IntroductionCard_hasDate":"IntroductionCard_hasDate___uBSg0"};